import React, {
  Fragment,
  useContext,
  useEffect,
  useRef,
  useState,
} from "react";
import { ThemeContext } from "../../context/ThemeContext";
import { useInfiniteQuery } from "@tanstack/react-query";
import { useDispatch, useSelector } from "react-redux";
import {
  getListWebUser,
  getFilteredWebUsers,
  updateUserStatus,
  changeUserAdminRole
} from "../../store/actions/user-profile.actions";
import {
  getNextPageFromURL,
  formatLocation,
  flattenQueryResults,
} from "../../utils/utils";
import { Modal, Collapse } from "react-bootstrap";
// import data from "../components/table/tableData";
import { Link } from "react-router-dom";
import Avatar from "react-avatar";
import { Dropdown } from "react-bootstrap";
import DatePicker from "react-datepicker";
import moment from "moment";
import { toast } from "react-toastify";
import Spinner from "react-bootstrap/Spinner";
import PreviewModal from "../components/bootstrap/previewModal";
const WebsiteUsersList = () => {
  const { changeBackground, background } = useContext(ThemeContext);
  const dispatch = useDispatch();
  const { userProfileInfo, loading } = useSelector(
    (state) => state.userProfile
  );
  const [searchQuery, setSearchQuery] = useState();
  const [newProject, setNewProject] = useState(false);
  const [startDate, setStartDate] = useState(new Date());
  const [datePeriod, setDatePeriod] = useState();
  const [suspenseUser, setSuspenseUser] = useState();
  const [showPreview, setShowPreview] = useState(false);
  const [previewContent, setPreviewContent] = useState(null);
  const [previewType, setPreviewType] = useState('text');
  const [filters, setFilters] = useState({
    dateRange: [null, null], // [startDate, endDate]
    country: "", // country filter instead of location
  });
  const [showFilters, setShowFilters] = useState(false);
  const today = moment();
  const columns = [
    "ID",
    "Profile",
    "Name",
    "Email",
    "Phone",
    "Location",
    "Role",
    "Beta",
    "Beta Status",
    "Action",
  ];

  const formatDateForAPI = (date) => {
    if (!date) return null;
    return moment(date).format('YYYY-MM-DD');
  };
  const svg1 = (
    <svg width="20px" height="20px" viewBox="0 0 24 24" version="1.1">
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <rect x="0" y="0" width="24" height="24"></rect>
        <circle fill="#000000" cx="5" cy="12" r="2"></circle>
        <circle fill="#000000" cx="12" cy="12" r="2"></circle>
        <circle fill="#000000" cx="19" cy="12" r="2"></circle>
      </g>
    </svg>
  );
  const calendaricon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      viewBox="0 0 48 48"
    >
      <mask id="ipSApplication0">
        <g fill="none" stroke="#fff" strokeLinejoin="round" strokeWidth="4">
          <path strokeLinecap="round" d="M40.04 22v20h-32V22"></path>
          <path
            fill="#fff"
            d="M5.842 13.777C4.312 17.737 7.263 22 11.51 22c3.314 0 6.019-2.686 6.019-6a6 6 0 0 0 6 6h1.018a6 6 0 0 0 6-6c0 3.314 2.706 6 6.02 6c4.248 0 7.201-4.265 5.67-8.228L39.234 6H8.845l-3.003 7.777Z"
          ></path>
        </g>
      </mask>
      <path
        fill="currentColor"
        d="M0 0h48v48H0z"
        mask="url(#ipSApplication0)"
      ></path>
    </svg>
  );
  const {
    data = { pages: [] },
    isFetching: adminUsersListFetching,
    isLoading: adminUsersListLoading,
    refetch: refetchAdminUsersList,
    fetchNextPage: adminUsersListFetchNextPage,
    hasNextPage: adminUsersListHasNextPage,
    hasPreviousPage: adminUsersListHasPrevPage,
    fetchPreviousPage: adminUsersListFetchPrevPage,
  } = useInfiniteQuery({
    queryKey: [
      "filtered-users-list", 
      searchQuery, 
      filters.dateRange[0], 
      filters.dateRange[1], 
      filters.country
    ],
    queryFn: async ({ queryKey, pageParam }) => {
      const [, search, startDate, endDate, country] = queryKey;
      
      // Use filtered API if any filters are applied, otherwise use regular API
      const hasFilters = startDate || endDate || country;
      
      if (hasFilters) {
        const resp = (
          await dispatch(getFilteredWebUsers({ 
            pageParam, 
            search: search,
            created_at_after: formatDateForAPI(startDate),
            created_at_before: formatDateForAPI(endDate),
            country: country || undefined
          }))
        )?.payload;
        return resp;
      } else {
        const resp = (
          await dispatch(getListWebUser({ pageParam, search: search }))
        )?.payload;
        return resp;
      }
    },
    getNextPageParam: (lastPage) => getNextPageFromURL(lastPage?.next),
    getPreviousPageParam: (lastPage) => getNextPageFromURL(lastPage?.previous),
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    changeBackground({ value: "light", label: "Light" });
    refetchAdminUsersList();
  }, []);

  useEffect(() => {
    if (searchQuery) {
      refetchAdminUsersList();
    }
  }, [searchQuery]);

  const sort = 10;

  const activePag = useRef(0);

  const allUsers = flattenQueryResults(data) ?? [];

  const getUserStatusMessage = (status) => {
    switch (status) {
      case 1:
        return { message: "Active", state: "success" };
      case 2:
        return { message: "Unverified", state: "info" };
      case 3:
        return { message: "Deleted", state: "dark" };
      case 4:
        return { message: "Banned", state: "danger" };
      case 5:
        return { message: "Suspended", state: "warning" };
      default:
        return { message: "Unverified", state: "info" };
    }
  };

  const getBetaStatusMessage = (status) => {
    if (!status) return { message: "N/A", state: "secondary" };
    
    switch (status.toLowerCase()) {
      case 'active':
        return { message: "Active", state: "success" };
      case 'verified':
        return { message: "Verified", state: "success" };
      case 'pending':
        return { message: "Pending", state: "info" };
      case 'unverified':
        return { message: "Unverified", state: "info" };
      case 'deleted':
        return { message: "Deleted", state: "dark" };
      case 'banned':
        return { message: "Banned", state: "danger" };
      case 'suspended':
        return { message: "Suspended", state: "warning" };
      case 'rejected':
        return { message: "Rejected", state: "danger" };
      case 'completed':
        return { message: "Completed", state: "success" };
      default:
        return { message: status, state: "info" };
    }
  };

  const handleRerictUser = (action, id) => {
    if (action === "SUSPENDED") {
      setNewProject(true);
      setSuspenseUser(id);
    } else {
      dispatch(
        updateUserStatus({
          action: action, //SUSPENDED //BANNED
          suspended_till: moment().format(),
          user_id: id,
        })
      ).then((res) => {
        if (res.payload.message) {
          refetchAdminUsersList();
          toast.success(res.payload.message, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: false,
            draggable: false,
          });
          setNewProject(false);
          setSuspenseUser();
        } else {
          toast.error("Something went wrong!", {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: false,
          });
        }
      });
    }
  };

  const handleChangeUserRole = (action, id) => {
    dispatch(changeUserAdminRole({user_id:id, role:action === 'SUPERADMIN' ? 1 : 2})).then((res) => {
      if (res.payload.message) {
        refetchAdminUsersList();
        toast.success(res.payload.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        });
        setNewProject(false);
        setSuspenseUser();
      } else {
        toast.error("Something went wrong!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      }
    });
  }

  const handleSuspendUser = () => {
    dispatch(
      updateUserStatus({
        action: "SUSPENDED", //SUSPENDED //BANNED
        suspended_till: datePeriod
          ? moment(datePeriod).utc().format()
          : moment(startDate).utc().format(),
        user_id: suspenseUser,
      })
    ).then((res) => {
      if (res.payload.message) {
        refetchAdminUsersList();
        toast.success(res.payload.message, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: false,
          pauseOnHover: false,
          draggable: false,
        });
        setNewProject(false);
        setSuspenseUser();
      } else {
        toast.error("Something went wrong!", {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: false,
          draggable: false,
        });
      }
      setDatePeriod();
      setStartDate(new Date());
    });
  };

  const handlePreviewClick = (content, type) => {
    setPreviewContent(content);
    setPreviewType(type);
    setShowPreview(true);
  };

  return (
    <Fragment>
      <div className="col-12">
        <div className="card">
          <div className="card-header">
            <h4 className="card-title">Users</h4>
            <button
              className="btn btn-secondary px-2 py-1"
              onClick={() => setShowFilters(!showFilters)}
            >
              <i className="fa fa-filter" />{' '}
              {showFilters ? "Hide Filters" : "Add Filters"}
            </button>
          </div>
          <div className="card-body">
            <div className="w-100 table-responsive">
              <div id="example_wrapper" className="dataTables_wrapper">
                {showFilters && (
                  <div className="filter-section mb-3">
                    <div className="row g-2">
                      {/* Date Range Picker */}
                      <div className="col-md-4 d-flex flex-column gap-2">
                        <label>Date Created (From - To)</label>
                        <DatePicker
                          selectsRange
                          startDate={filters.dateRange[0]}
                          endDate={filters.dateRange[1]}
                          onChange={(update) => setFilters({...filters, dateRange: update})}
                          isClearable
                          className="form-control w-100"
                          placeholderText="Select date range"
                          dateFormat="yyyy-MM-dd"
                        />
                      </div>

                      {/* Country Filter */}
                      <div className="col-md-4 d-flex flex-column gap-2">
                        <label>Country</label>
                        <div className="position-relative">
                          <select
                            className="form-control w-100"
                            value={filters.country}
                            onChange={(e) => setFilters({...filters, country: e.target.value})}
                          >
                            <option value="">Select Country</option>
                            <option value="United States">United States</option>
                            <option value="Canada">Canada</option>
                            <option value="United Kingdom">United Kingdom</option>
                            <option value="Australia">Australia</option>
                            <option value="Germany">Germany</option>
                            <option value="France">France</option>
                            <option value="Italy">Italy</option>
                            <option value="Spain">Spain</option>
                            <option value="Netherlands">Netherlands</option>
                            <option value="Sweden">Sweden</option>
                            <option value="Norway">Norway</option>
                            <option value="Denmark">Denmark</option>
                            <option value="Japan">Japan</option>
                            <option value="South Korea">South Korea</option>
                            <option value="China">China</option>
                            <option value="India">India</option>
                            <option value="Brazil">Brazil</option>
                            <option value="Mexico">Mexico</option>
                            <option value="Argentina">Argentina</option>
                            <option value="South Africa">South Africa</option>
                            <option value="Nigeria">Nigeria</option>
                            <option value="Egypt">Egypt</option>
                            <option value="Russia">Russia</option>
                            <option value="Turkey">Turkey</option>
                            <option value="Saudi Arabia">Saudi Arabia</option>
                            <option value="UAE">UAE</option>
                            <option value="Singapore">Singapore</option>
                            <option value="Malaysia">Malaysia</option>
                            <option value="Thailand">Thailand</option>
                            <option value="Indonesia">Indonesia</option>
                            <option value="Philippines">Philippines</option>
                            <option value="Vietnam">Vietnam</option>
                            <option value="New Zealand">New Zealand</option>
                            <option value="Ireland">Ireland</option>
                            <option value="Belgium">Belgium</option>
                            <option value="Switzerland">Switzerland</option>
                            <option value="Austria">Austria</option>
                            <option value="Poland">Poland</option>
                            <option value="Czech Republic">Czech Republic</option>
                            <option value="Hungary">Hungary</option>
                            <option value="Portugal">Portugal</option>
                            <option value="Greece">Greece</option>
                            <option value="Israel">Israel</option>
                            <option value="Chile">Chile</option>
                            <option value="Colombia">Colombia</option>
                            <option value="Peru">Peru</option>
                            <option value="Venezuela">Venezuela</option>
                            <option value="Ecuador">Ecuador</option>
                            <option value="Uruguay">Uruguay</option>
                            <option value="Paraguay">Paraguay</option>
                            <option value="Bolivia">Bolivia</option>
                            <option value="Kenya">Kenya</option>
                            <option value="Ghana">Ghana</option>
                            <option value="Morocco">Morocco</option>
                            <option value="Algeria">Algeria</option>
                            <option value="Tunisia">Tunisia</option>
                            <option value="Libya">Libya</option>
                            <option value="Sudan">Sudan</option>
                            <option value="Ethiopia">Ethiopia</option>
                            <option value="Uganda">Uganda</option>
                            <option value="Tanzania">Tanzania</option>
                            <option value="Zambia">Zambia</option>
                            <option value="Zimbabwe">Zimbabwe</option>
                            <option value="Botswana">Botswana</option>
                            <option value="Namibia">Namibia</option>
                            <option value="Mozambique">Mozambique</option>
                            <option value="Madagascar">Madagascar</option>
                            <option value="Mauritius">Mauritius</option>
                            <option value="Seychelles">Seychelles</option>
                            <option value="Pakistan">Pakistan</option>
                            <option value="Bangladesh">Bangladesh</option>
                            <option value="Sri Lanka">Sri Lanka</option>
                            <option value="Nepal">Nepal</option>
                            <option value="Bhutan">Bhutan</option>
                            <option value="Maldives">Maldives</option>
                            <option value="Afghanistan">Afghanistan</option>
                            <option value="Iran">Iran</option>
                            <option value="Iraq">Iraq</option>
                            <option value="Jordan">Jordan</option>
                            <option value="Lebanon">Lebanon</option>
                            <option value="Syria">Syria</option>
                            <option value="Yemen">Yemen</option>
                            <option value="Oman">Oman</option>
                            <option value="Qatar">Qatar</option>
                            <option value="Bahrain">Bahrain</option>
                            <option value="Kuwait">Kuwait</option>
                          </select>
                          {filters.country && (
                              <button
                                type="button"
                                className="btn btn-sm position-absolute"
                                style={{
                                  right: '-18px',
                                  top: '50%',
                                  transform: 'translateY(-48%)',
                                  border: 'none',
                                  background: '#216BA5',
                                  padding: '0',
                                  zIndex: 10,
                                  borderRadius: '100%',
                                  height: '15px',
                                  width: '15px',
                                  color: '#ffffff',
                                  fontSize: '10px',
                                  cursor: 'pointer',
                                  transition: 'color 0.3s ease',
                                  backgroundColor: 'blue',
                                  display: 'flex',
                                  alignItems: 'center',
                                  justifyContent: 'center'
                                }}
                                onClick={() => setFilters({...filters, country: ""})}
                              >
                                <i className="fa fa-times text-white"></i>
                              </button>
                            )}
                        </div>
                      </div>


                      {/* Clear Filters Button - Only show when filters are applied */}
                      <div className="col-md-4 d-flex align-items-end justify-content-end">
                        {(filters.dateRange[0] || filters.dateRange[1] || filters.country) && (
                          <button
                            className="btn btn-primary w-auto px-2 py-1"
                            onClick={() => setFilters({ dateRange: [null, null], country: "" })}
                          >
                            <i className="fa fa-times" />{' '}
                            Clear Filters
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                <div id="example_filter" class="dataTables_filter">
                  <label>
                    Search:
                    <input
                      type="search"
                      class=""
                      placeholder=""
                      aria-controls="example"
                      onChange={(e) => setSearchQuery(e.target.value)}
                    />
                  </label>
                </div>
                {adminUsersListFetching || adminUsersListLoading ? (
                  <div className="d-flex justify-content-center">
                    <Spinner animation="border" variant="primary" />
                  </div>
                ) : (
                  <table id="example3" className="display w-100 dataTable">
                    <thead>
                      <tr role="row">
                        {columns.map((d, i) => (
                          <th key={i}>{d}</th>
                        ))}
                      </tr>
                    </thead>
                    <tbody>
                      {allUsers?.length ? (
                        allUsers?.map((d, i) => (
                          <tr key={i}>
                            <Fragment key={i}>
                              <td>{d?.id}</td>
                              <td onClick={() => handlePreviewClick(d?.profile_pic, 'image')} className="cursor-pointer">
                                <Avatar
                                  size="40"
                                  round={true}
                                  name={`${d?.first_name} ${d?.last_name}`}
                                  src={d?.profile_pic}
                                />
                              </td>
                              <td>{`${d?.first_name} ${d?.last_name}`}</td>
                              <td>{d?.email}</td>
                              <td>{d?.mobile_number}</td>
                              <td>{d?.country}</td>
                              <td>
                                <span
                                  className={`badge badge-rounded badge-${
                                    getUserStatusMessage(d?.status)?.state
                                  }`}
                                >
                                  {getUserStatusMessage(d?.status)?.message}
                                </span>
                              </td>
                              <td>
                                {d?.is_beta ? (
                                  <span className="badge badge-rounded badge-success">Yes</span>
                                ) : (
                                  <span className="badge badge-rounded badge-primary">No</span>
                                )}
                              </td>
                              <td>
                                <span
                                  className={`badge badge-rounded badge-${
                                    getBetaStatusMessage(d?.beta_status)?.state
                                  }`}
                                >
                                  {getBetaStatusMessage(d?.beta_status)?.message}
                                </span>
                              </td>
                              <td>
                                <Dropdown>
                                  <Dropdown.Toggle
                                    variant={
                                      getUserStatusMessage(d?.status)?.state
                                    }
                                    className="light sharp i-false"
                                  >
                                    {svg1}
                                  </Dropdown.Toggle>
                                  <Dropdown.Menu>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleRerictUser("ACTIVE", d?.id)
                                      }
                                    >
                                      Activate
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleRerictUser("SUSPENDED", d?.id)
                                      }
                                    >
                                      Suspend
                                    </Dropdown.Item>
                                    <Dropdown.Item
                                      onClick={() =>
                                        handleRerictUser("BANNED", d?.id)
                                      }
                                    >
                                      Ban
                                    </Dropdown.Item>
                                    {userProfileInfo?.role === 1 && <Dropdown.Item
                                      onClick={() =>
                                        handleChangeUserRole("ADMIN", d?.id)
                                      }
                                    >
                                      Make admin
                                    </Dropdown.Item>}
                                    {userProfileInfo?.role === 1 && <Dropdown.Item
                                      onClick={() =>
                                        handleChangeUserRole("SUPERADMIN", d?.id)
                                      }
                                    >
                                      Make super admin
                                    </Dropdown.Item>}
                                  </Dropdown.Menu>
                                </Dropdown>
                              </td>
                            </Fragment>
                          </tr>
                        ))
                      ) : (
                        <></>
                      )}
                    </tbody>
                    <tfoot>
                      <tr role="row">
                        {columns.map((d, i) => (
                          <th key={i}>{d}</th>
                        ))}
                      </tr>
                    </tfoot>
                  </table>
                )}
                <div className="d-sm-flex text-center justify-content-between align-items-center mt-3 dataTables_info_users">
                  <div className="dataTables_info">
                    Showing {activePag.current * sort + 1} to {allUsers?.length}{" "}
                    of {data?.pages[0]?.count} entries
                  </div>
                  <div className="dataTables_paginate paging_simple_numbers">
                    <div
                      className="dataTables_paginate paging_simple_numbers"
                      id="example5_paginate"
                    >
                      {adminUsersListHasPrevPage && (
                        <Link
                          className="paginate_button previous disabled"
                          onClick={() => adminUsersListFetchPrevPage()}
                        >
                          Previous
                        </Link>
                      )}

                      {adminUsersListHasNextPage && (
                        <Link
                          className="paginate_button next"
                          onClick={() => adminUsersListFetchNextPage()}
                        >
                          Next
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        className="modal fade"
        size="md"
        id="addProjectSidebar"
        show={newProject}
        onHide={setNewProject}
      >
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Select suspension period</h5>
            <button
              type="button"
              className="btn-close"
              onClick={() => setNewProject(false)}
            ></button>
          </div>
          <div className="modal-body">
            <div className="form-group">
              <label className="text-black font-w500">Select Period</label>
              <select
                onChange={(e) => setDatePeriod(e.target.value)}
                placeholder="Select Period"
                className="form-control"
              >
                <option>Choose period</option>
                <option value={moment().add(1, "week").format()}>1 Week</option>
                <option value={moment().add(1, "month").format()}>
                  1 Month
                </option>
                <option value={moment().add(1, "year").format()}>1 Year</option>
              </select>
            </div>
            <div className="d-flex justify-content-center">OR</div>
            <div className="form-group date-picker-full">
              <label className="text-black font-w500">Pick a date</label>
              <br />
              <DatePicker
                showIcon
                icon={calendaricon}
                selected={startDate}
                onChange={(date) => setStartDate(date)}
                className="form-control w-100"
                dateFormat="MM-dd-yyyy"
                minDate={new Date()}
              />
            </div>
            {/* <div className="form-group">
                <label className="text-black font-w500">Role</label>
                <input type="text" className="form-control" />
              </div> */}
            <div className="form-group">
              <button
                onClick={() => handleSuspendUser()}
                className="btn btn-primary"
              >
                Suspend
              </button>
            </div>
          </div>
        </div>
      </Modal>
      <PreviewModal
        show={showPreview && previewContent?.length > 0}
        onHide={() => setShowPreview(false)}
        content={previewContent}
        type={previewType}
      />
    </Fragment>
  );
};
export default WebsiteUsersList;
